// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconUserCheck, IconBasket, IconMessages, 
    IconLayoutKanban, IconMail, IconCalendar, 
    IconNfc,
    IconBook,
    IconUserCircle 
} from "@tabler/icons-react"

// constant
const icons = {
    IconUserCheck,
    IconBasket,
    IconMessages,
    IconLayoutKanban,
    IconMail,
    IconCalendar,
    IconNfc
};

// ==============================|| APPLICATION MENU ITEMS ||============================== //
const cours = {
    id: 'cours',
    title: ["E. ", <FormattedMessage id="cours" />],
    type: 'group',
    icon: <IconBook />, // Use a valid icon component here
    /* children: [
        {
            id: 'funcoes2',
            title: <FormattedMessage id="gestion_cours" />,
            type: 'collapse',
            icon: IconBook, */
            children: [

                
                {
                    id: 'dureeCours',
                    title: ["1. ",<FormattedMessage id="duree_cours" />],
                    type: 'item',
                    url: '/cours/dureeCours'
                },

                {
                    id: 'groupeCours1',
                    title: ["1.1. ",<FormattedMessage id="domaineCours" />],
                    type: 'item',
                    url: '/cours/coursDomaine'
                },

                {
                    id: 'turnos',
                    title: ["2. ", <FormattedMessage id="turno" />],
                    type: 'item',
                    url: '/turno'
                },
                {
                    id: 'niveauAcademiq',
                    title: ["3. ", <FormattedMessage id="niveau_academiqes" />],
                    type: 'item',
                    url: '/anofrequencia'
                 },

                {
                    id: 'turma1',
                    title: ["4. ",<FormattedMessage id="turmas" />],
                    type: 'item',
                    url: '/turma'
                },
                {
                    id: 'option_',
                    title: ["5. ", <FormattedMessage id="options" />],
                    type: 'item',
                    url: '/options'
                },

                {
                    id: 'unitedeCours1',
                    title: ["5. ", <FormattedMessage id="unite_enseignement_titre" />],
                    type: 'item',
                    url: '/uniteEngnement'
                },

                {
                    id: 'enregistrerCours',
                    title: ["6. ", <FormattedMessage id="enregistrer_cours" />],
                    type: 'item',
                    url: '/cours/enregistrercours'
                },

                /*  {
                    id: 'type_inscription_normal_attribuer_cours_etudiant1',
                    title: ["7. ", <FormattedMessage id="type_inscription_normal_attribuer_cours_etudiant" />],
                    type: 'item',
                    url: '/cours/coursSpeciaux'
                }, */
                {
                    id: 'listCours1',
                    title: ["7. ",<FormattedMessage id="liste_cours" />],
                    type: 'item',
                    url: '/cours/coursList'
                },

                {
                    id: 'coursPlan1',
                    title: ["8. ",<FormattedMessage id="plandu_cours" />],
                    type: 'item',
                    url: '/cours/coursPlan'
                },

                {
                    id: 'precedencesCours1',
                    title: ["9. ",<FormattedMessage id="precedencesCours" />],
                    type: 'item',
                    url: '/cours/coursPlan'
                },

                
                    
                    ],
               //   },
        
 //   ]
};

export default cours;
